
import {Component, Prop, Vue} from 'vue-property-decorator';
import {ProjectDocument} from "@/interfaces/project.interfaces";
import {
  copyBuffer,
  copyDataset,
  copyGoalsCases,
  copyJobs,
  copyProject,
  copyReleases,
  copyScreens,
  copyTerminals,
  copyTestcases,
  copyTestgoals,
  copyTools,
  copyToys,
  copyTreeNodes,
  copyVariables
} from "@/axios/axios.copy_project";

@Component({})
export default class SAccCopyRepo extends Vue {
  // Les props
  @Prop() private projects!: ProjectDocument[]

  // Les propriétés
  private isVisible: boolean = false
  private fromPrj: string | null = null
  private item: string = ''
  private progress: number = 0
  private nbitems: number = 14
  private loading: boolean = false

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private async onCopy() {
    if (this.fromPrj) {
      this.loading = true
      const toPrj = await copyProject(this.fromPrj)
      if (toPrj) {
        this.log('Tree nodes', 1)
        await copyTreeNodes(this.fromPrj, toPrj._id)
        this.log('Releases', 2)
        await copyReleases(this.fromPrj, toPrj._id)
        this.log('Variables', 3)
        await copyVariables(this.fromPrj, toPrj._id)
        this.log('Screens', 4)
        await copyScreens(this.fromPrj, toPrj._id)
        this.log('Tools', 6)
        await copyTools(this.fromPrj, toPrj._id)
        this.log('Toys', 7)
        await copyToys(toPrj._id)
        this.log('Buffers',8)
        await copyBuffer(this.fromPrj, toPrj._id)
        this.log('Dataset', 9)
        await copyDataset(toPrj._id)
        this.log('Terminals',10)
        await copyTerminals(this.fromPrj, toPrj._id)
        this.log('Test cases',11)
        await copyTestcases(this.fromPrj, toPrj._id)
        this.log('Test goals',12)
        await copyTestgoals(this.fromPrj, toPrj._id)
        this.log('Goals/Cases',13)
        await copyGoalsCases(toPrj._id)
        this.log('Test Jobs',14)
        await copyJobs(this.fromPrj, toPrj._id)
      }
      this.loading = false
      this.$emit('copied', toPrj)
    }
    this.isVisible = false
  }

  // Les méthodes statiques
  private log(item: string, progress: number) {
    this.item = item
    this.progress = progress
    // console.log(`item: ${this.item}, progress: ${this.progress}`)
  }

}
